export default __webpack_public_path__ + "static/media/J724_RoHS.515f9d49.pdf";